import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { v4 as uuidv4 } from 'uuid';

import LabelLoader from '../LabelLoader/LabelLoader';
import ParagraphLoader from '../ParagraphLoader/ParagraphLoader';

import 'react-loading-skeleton/dist/skeleton.css';
import styles from './CompanyAboutLoader.module.scss';

const SkeletonBlock = ({ className, height }) => (
  <div className={className}>
    <Skeleton borderRadius={6} height={height} />
  </div>
);

const SectionSkeleton = () => (
  <div>
    <SkeletonBlock className={styles.heading} height={24} />
    <div>
      <ParagraphLoader height={10} />
    </div>
  </div>
);

const CompanyAboutLoader = () => (
  <div className={styles.container}>
    <div className={styles.subContainer}>
      {[...Array(5)].map(() => (
        <SectionSkeleton key={uuidv4()} />
      ))}
    </div>
    <SkeletonBlock className={styles.Labelheading} height={24} />
    <div className={styles.labelContainer}>
      <LabelLoader widthClass="labelWidth10" />
      <LabelLoader widthClass="labelWidth15" />
      <LabelLoader widthClass="labelWidth20" />
    </div>
  </div>
);

export default CompanyAboutLoader;
